import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { PagePanel, Box, Button, LoginIcon } from 'edenred-ui';

import { goToPage } from '@epi-actions/navigation';
import emailConfirmedImage from '@epi-assets/images/EmailConfirmed.jpg';
import { routerPaths } from '@epi-constants/routerPaths';
import { EmptyState } from '@epi-shared/components';

import { CoverImage } from './ConfirmedMessage.styles';

export const ConfirmedMessage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const goToHomePage = () => {
    dispatch(goToPage(routerPaths.home));
  };

  return (
    <PagePanel hasContentPadding={false} hasOverflow={false}>
      <Box display="flex" height="100%">
        <Box flex={1} overflow="hidden">
          <CoverImage src={emailConfirmedImage} alt="" />
        </Box>
        <Box
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <EmptyState
            icon={<LoginIcon />}
            title={
              <Box textAlign="center">
                <Trans i18nKey={t('email_verification.title')} />
              </Box>
            }
            description={t('email_verification.description')}
          >
            <Box mt={6.5} mb={6.5}>
              <Button id="go-to-homepage" onClick={goToHomePage}>
                {t('email_verification.action_btn')}
              </Button>
            </Box>
          </EmptyState>
        </Box>
      </Box>
    </PagePanel>
  );
};
